import React from 'react';
import PipelineLoadingOverlay from './PipelineLoadingOverlay';

interface QBRLoadingOverlayProps {
  isVisible: boolean;
  message?: string;
  progress?: number;
  query?: string;
}

const QBRLoadingOverlay: React.FC<QBRLoadingOverlayProps> = ({ 
  isVisible, 
  message = "Generating QBR Report",
  progress = 0,
  query
}) => {
  return (
    <PipelineLoadingOverlay
      isVisible={isVisible}
      requestType="qbr_generation"
      query={query || message}
      progress={progress}
    />
  );
};

export default QBRLoadingOverlay;
